import { createFileRoute } from '@tanstack/react-router';

import { DemandDefinitionOverlay } from '../demand-definition/components/DemandDefinitionOverlay';

const CreateDemandDefinitionRoute = () => {
    const { substep } = Route.useParams();

    return <DemandDefinitionOverlay substep={substep} />;
};

export const Route = createFileRoute('/_app/demand-definitions/create/$substep')({
    component: CreateDemandDefinitionRoute,
});
